import { S3_BASE_URL } from "./const";
import dayjs from "dayjs";

export const getS3Url = (url) => {
  const s3url = `${S3_BASE_URL}/${url}`;
  return s3url;
};

export const formatDate = (dateString) => {
  if (!dateString) return "-";
  const [year, month, day] = dateString.split("-");
  return `${day}-${month}-${year}`;
};

export const calculateTotalWithInterest = (loanAmount, annualRate, loanDate, tillDate = new Date()) => {
  if (!loanAmount || !annualRate || !loanDate) return 0;

  const principal = parseFloat(loanAmount);
  const rate = parseFloat(annualRate);

  // Calculate days between the two dates
  const start = new Date(loanDate);
  const end = new Date(tillDate);
  const diffInDays = Math.floor((end - start) / (1000 * 60 * 60 * 24));

  // Simple interest calculation
  const interest = (principal * rate * diffInDays) / (100 * 365);

  return interest
}

// Utility function to generate last 12 months labels
export const generateLast12Months = () => {
  const months = [];
  for (let i = 11; i >= 0; i--) {
    months.push(dayjs().subtract(i, "month").format("MMM YYYY"));
  }
  return months;
};

export const sumPayments = (payments) =>
  payments.reduce((acc, { paymentType, amount }) => {
    acc[paymentType] = (acc[paymentType] || 0) + Number(amount);
    return acc;
  }, {});

// Razorpay signature verification
export const loadRazorpay = () => {
  return new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);

    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};